import React, { useRef, useState } from "react"
import { connect } from "react-redux"
import ChatWindowDM from "./ChatWindowDM"
import addCircle from "../../assets/images/inbox/add_circle_black_24dp.svg"
import { Button, Col, Row, Spinner } from "reactstrap"
import { getFileBytes, returnMediaType } from "utils"
import CommentBoard from "./CommentBoard"
import NewsFeeds from "./NewsFeeds"
import {
  loadInboxMessages,
  sendInboxMessage,
  updateMessageLikes,
} from "store/actions"

const InboxChatBox = ({
  selectedChat,
  authUser,
  messageListIsLoading,
  messages,
  inboxSession,
  chatCred,
  chatUsers,
  getInboxChatUsers,
  loadInboxMessages,
  likes,
  vendorId,
  updateMessageLikes,
  sendInboxMessage,
  sendingMessage,
}) => {
  const handleLoadMore = () => {
    if (!selectedChat) return
    if (!!messages && messages?.items?.length > 0) {
      loadInboxMessages({
        dialog: selectedChat,
        beforeDateSent: messages.items[0].date_sent,
      })
    } else {
      loadInboxMessages({ dialog: selectedChat, beforeDateSent: null })
    }
  }

  const handleLike = (like, dialogId, messageId) => {
    const data = {
      message_qb_id: messageId,
      liked_by_me: !!like ? !like?.liked_by_me : true,
      total_likes: !!like
        ? like?.liked_by_me
          ? like?.total_likes - 1
          : like?.total_likes + 1
        : 1,
      dialog_id: dialogId,
      vendorId: vendorId,
    }
    updateMessageLikes(data)
  }

  const [inputMessage, setInputMessage] = useState("")
  const [uploadedFile, setUploadedFile] = useState(null)
  const attachmentRef = useRef(null)

  const handleFileUpload = async event => {
    const files = event.target.files
    if (files.length) {
      const file = files[0]
      const MAX_SIZE = 50 * 1024 * 1024 // 50 MB max file size
      if (returnMediaType(file?.type) === false) {
        alert(`File ${file?.name} has an invalid format.`)
        attachmentRef.current.value = null
      } else {
        if (file?.size > MAX_SIZE) {
          alert(`File ${file?.name} is too big. The maximum limit is 50 MB.`)
          attachmentRef.current.value = null
        } else {
          const attachmentType = file.type.split("/")[0]
          const attachment = await getFileBytes(file)
          setUploadedFile({
            file: file,
            media: attachment,
            type: attachmentType,
          })
        }
      }
    }
  }

  const handleSendMessage = () => {
    if (!!uploadedFile || inputMessage?.trim()?.length) {
      sendInboxMessage({
        xmpp_room_jid: selectedChat.xmpp_room_jid,
        file: uploadedFile,
        message: inputMessage,
        feature_type: selectedChat?.feature_type,
        event_id: selectedChat?.data?.event_id,
        menu_item_id: selectedChat?.data?.menu_item_id,
        sender_id: authUser?.id,
        vendor_id: vendorId,
        dialog_id: selectedChat?._id,
        receiver_ids: !!selectedChat?.userList
          ? selectedChat?.userList
              ?.filter(x => x?.id !== authUser?.id)
              ?.map(x => x?.id)
          : [],
        dialog_type: selectedChat?.type,
        opponent_id: selectedChat?.occupants_ids?.filter(
          occupantId => occupantId != chatCred?.qb_id
        ),
        qbId: chatCred?.qb_id,
      })
      setUploadedFile(null)
      attachmentRef.current.value = null
      setInputMessage("")
    }
  }

  const renderContent = () => {
    switch (selectedChat?.feature_type) {
      case 1:
        return (
          <CommentBoard
            selectedChat={selectedChat}
            messages={messages}
            chatCred={chatCred}
            inboxSession={inboxSession}
            chatUsers={chatUsers}
            getInboxChatUsers={getInboxChatUsers}
            handleLoadMore={handleLoadMore}
            authUser={authUser}
          />
        )
      case 2:
        return (
          <ChatWindowDM
            selectedChat={selectedChat}
            chatCred={chatCred}
            messages={messages}
            inboxSession={inboxSession}
            handleLoadMore={handleLoadMore}
          />
        )
      case 3:
        return (
          <NewsFeeds
            selectedChat={selectedChat}
            messages={messages}
            chatCred={chatCred}
            inboxSession={inboxSession}
            handleLoadMore={handleLoadMore}
            chatUsers={chatUsers}
            getInboxChatUsers={getInboxChatUsers}
            likes={likes}
            handleLikeMessage={handleLike}
            authUser={authUser}
          />
        )
      default:
        return <></>
    }
  }

  return (
    <React.Fragment>
      {renderContent()}
      <div className="chat-footer m-0 d-block">
        {!!uploadedFile && (
          <Row className="mb-3">
            <Col
              xs="auto"
              style={{
                position: "relative",
              }}
            >
              {uploadedFile?.type === "image" && (
                <img
                  className="avatar-lg"
                  src={uploadedFile?.media}
                  style={{ blockSize: "auto" }}
                />
              )}
              {uploadedFile?.type === "video" && (
                <video
                  className="avatar-lg"
                  src={uploadedFile?.media}
                  style={{ blockSize: "auto" }}
                  controls
                />
              )}
              <i
                className="bx bx-x"
                style={{
                  position: "absolute",
                  top: "5%",
                  right: "12%",
                  cursor: "pointer",
                  fontSize: "18px",
                  borderRadius: "15px",
                  backgroundColor: "white",
                  color: "black",
                }}
                onClick={() => {
                  setUploadedFile(null)
                  attachmentRef.current.value = null
                }}
              />
            </Col>
          </Row>
        )}
        <div className="d-flex w-100 align-items-center">
          <div className="d-flex w-100 align-items-center">
            <label htmlFor="commentImage" className="btn-rounded-sm btn m-0">
              <input
                onChange={handleFileUpload}
                type="file"
                id="commentImage"
                accept="image/jpg,image/jpeg,image/png,image/gif,jpg,jpeg,png,gif,mp4,video/mp4"
                className="h-0 invisible"
                style={{ width: "0px" }}
                ref={attachmentRef}
              />
              <img src={addCircle} alt="Add Image" />
            </label>
            <input
              type="text"
              value={inputMessage}
              onChange={e => {
                setInputMessage(e.target.value)
              }}
              className="message-input"
              placeholder="Enter Message..."
              onKeyDown={e => {
                if (e.key === "Enter") {
                  handleSendMessage()
                }
              }}
            />
          </div>
          <Button
            type="button"
            color="primary"
            onClick={handleSendMessage}
            className="btn-rounded chat-send w-md"
            disabled={sendingMessage}
          >
            {sendingMessage && <Spinner size={"sm"} color="light" />}
            <span className="d-none d-sm-inline-block me-2 ms-1">Send</span>
            <i className="mdi mdi-send"></i>
          </Button>
        </div>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  chatCred: state.Login.authUser.chat_credentials,
  authUser: state.Login.authUser,
  messages: state.Inbox.messages,
  messageListIsLoading: state.Inbox.messageListIsLoading,
  inboxSession: state.Inbox.inboxSession,
  likes: state.Inbox.likes,
  vendorId: state.Login.vendorId,
  sendingMessage: state.Inbox.sendingMessage,
})

const mapDispatchToProps = dispatch => ({
  loadInboxMessages: values => dispatch(loadInboxMessages(values)),
  updateMessageLikes: values => dispatch(updateMessageLikes(values)),
  sendInboxMessage: values => dispatch(sendInboxMessage(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(InboxChatBox)
